import { useMemo } from "react";
import { useShop } from "./ShopContext";

const useFullUrl = (url, withDomain = true) => {
  const shop = useShop();
  return useMemo(() => {
    const path =
      typeof url === "string" ? url.replace(/^[^/].*$/, () => "/" + url) : "/";
    const baseUrl = shop ? (withDomain ? shop.url : shop.baseUrl) : "";
    return baseUrl + path;
  }, [url, shop, withDomain]);
};

export default useFullUrl;
